import React, { Component, Fragment } from "react";
import { Card, Icon, Tag, Radio, Row, Col } from "antd";
import WizardFooter from "./wizard-footer";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import ZillowHomeValueContainer from "./zillow-home-value-container_updated";

const RadioGroup = Radio.Group;

class Step extends Component {
  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    return (
      <Fragment>
        <div className="stepBody">
          <Card className="insidecard stepcard">
            <h5>"Do you own your primary home?" <span className='asteriskIcon'>*</span></h5>
            <RadioGroup className="radiogroup"
              value={wizard.home_toggle}
              onChange={(e) => {
                updateField("home_toggle", e.target.value);
                if (!this.props.isExternalBFile) {
                  updateRadioBtnToggle();
                }
              }}
            >
              <Radio value="1" className="">
                <Translate text={`Yes`} />
              </Radio>
              <Radio value="0" className="">
                <Translate text={`No`} />
              </Radio>
              <Radio value="2" className="">
                <Translate text={`Rent`} />
              </Radio>
            </RadioGroup>
            {wizard.home_toggle === "1" ? (
              <ZillowHomeValueContainer {...this.props} />
            ) : null}

            <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know </h4>
                <p className="textContent">"The equity in your home may be at risk in the event of a liability lawsuit."</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step3_updated.js